import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CommunityVerbsSection from './components/CommunityVerbsSection';
import CommunityStatsSection from './components/CommunityStatsSection';
import RfwTvSection from './components/RfwTvSection';
import FeaturedRadios from './components/FeaturedRadios';
import Categories from './components/Categories';
import AboutSection from './components/AboutSection';
import BenefitsRadios from './components/BenefitsRadios';
import BenefitsListeners from './components/BenefitsListeners';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import SponsorsSection from './components/SponsorsSection';
import StatsSection from './components/StatsSection';
import PlansSection from './components/PlansSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';
import InlineBannerAd from './components/InlineBannerAd';
import MobileAdCarousel from './components/MobileAdCarousel';
import RecommendationSection from '@/components/feature/RecommendationSection';
import { generateGenericRecommendations } from '@/mocks/recommendations';
import { inlineBanners, heroLeftAds, heroRightAds, footerSponsor } from '@/mocks/ads';
import ExclusivitySection from './components/ExclusivitySection';
import ComunidadSection from './components/ComunidadSection';
import GamificacionTotalSection from './components/GamificacionTotalSection';
import TopRankingsSection from './components/TopRankingsSection';
import ClubesSection from './components/ClubesSection';
import MonetizacionSection from './components/MonetizacionSection';
import RedPublicitariaSection from './components/RedPublicitariaSection';
import MarketplaceSection from './components/MarketplaceSection';
import AppsSection from './components/AppsSection';
import TestimoniosCrecimientoSection from './components/TestimoniosCrecimientoSection';
import AuditoriaLandingSection from './components/AuditoriaLandingSection';
import CompetenciasSection from './components/CompetenciasSection';
import SocialSection from './components/SocialSection';
import PublicidadSection from './components/PublicidadSection';
import NotificacionesInteligentesSection from './components/NotificacionesInteligentesSection';
import LandingVivaSection from './components/LandingVivaSection';
import ReputacionSection from './components/ReputacionSection';
import GanadoresSection from './components/GanadoresSection';
import PatrocinadoresSection from './components/PatrocinadoresSection';
import CopasSection from './components/CopasSection';
import EventosSection from './components/EventosSection';
import EncuestasSection from './components/EncuestasSection';
import TriviasSection from './components/TriviasSection';
import SeguidoresSection from './components/SeguidoresSection';
import CompartidosSection from './components/CompartidosSection';
import MapaSection from './components/MapaSection';
import LogrosSection from './components/LogrosSection';
import TopFansGlobalesSection from './components/TopFansGlobalesSection';
import EmbajadoresSection from './components/EmbajadoresSection';
import RetosClubesSection from './components/RetosClubesSection';
import VipClubSection from './components/VipClubSection';
import InsigniasSection from './components/InsigniasSection';
import ReaccionesSection from './components/ReaccionesSection';
import GuardadosSection from './components/GuardadosSection';
import CentroNotificacionesSection from './components/CentroNotificacionesSection';
import PerfilOyenteSection from './components/PerfilOyenteSection';
import SeguirUsuariosSection from './components/SeguirUsuariosSection';
import CentroSocialSection from './components/CentroSocialSection';
import MensajesPrivadosSection from './components/MensajesPrivadosSection';
import ModeradoresSection from './components/ModeradoresSection';
import ReportesSection from './components/ReportesSection';
import VerificacionSection from './components/VerificacionSection';
import FavoritosSection from './components/FavoritosSection';
import AchievementsEnVivoSection from './components/AchievementsEnVivoSection';
import RachasSection from './components/RachasSection';
import AniversariosSection from './components/AniversariosSection';
import BienvenidaSection from './components/BienvenidaSection';
import ActividadGlobalSection from './components/ActividadGlobalSection';
import CanalRFWSection from './components/CanalRFWSection';
import OnboardingRadiosSection from './components/OnboardingRadiosSection';
import StreamingSection from './components/StreamingSection';
import DashboardSimpleSection from './components/DashboardSimpleSection';
import CentroTransmisionSection from './components/CentroTransmisionSection';
import ProgramacionAutomaticaSection from './components/ProgramacionAutomaticaSection';
import SistemaLocutoresSection from './components/SistemaLocutoresSection';
import SistemaProgramasSection from './components/SistemaProgramasSection';
import Cabina2Section from './components/Cabina2Section';
import CancionesSolicitadasSection from './components/CancionesSolicitadasSection';
import SistemaSaludosSection from './components/SistemaSaludosSection';
import AudioMensajesSection from './components/AudioMensajesSection';
import EventosEnVivoSection from './components/EventosEnVivoSection';
import ClipsSection from './components/ClipsSection';
import TendenciasEnVivoSection from './components/TendenciasEnVivoSection';
import RadiosVerificadasSection from './components/RadiosVerificadasSection';
import RadiosCercanasSection from './components/RadiosCercanasSection';
import DescubrimientoSection from './components/DescubrimientoSection';
import DiscoverySection from './components/DiscoverySection';
import PatrocinadoresLocalesSection from './components/PatrocinadoresLocalesSection';
import Top10GlobalSection from './components/Top10GlobalSection';
import Top10PaisSection from './components/Top10PaisSection';
import Top10CategoriaSection from './components/Top10CategoriaSection';

export default function Home() {
  const genericRecommendations = generateGenericRecommendations(8);
  const [activeCategory, setActiveCategory] = useState('Todas');

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Header />
      <main>
        <HeroSection />

        <DiscoverySection />

        {/* ── Community Verbs — justo después del Hero ── */}
        <CommunityVerbsSection />

        {/* ── Community Stats — estadísticas de la comunidad ── */}
        <CommunityStatsSection />

        {/* ── RFW TV — el canal oficial ── */}
        <RfwTvSection />

        {/* Anuncios mobile: carrusel justo debajo del hero */}
        <MobileAdCarousel
          sideAds={[...heroLeftAds, ...heroRightAds]}
          banners={inlineBanners}
          className="py-6 bg-background-100"
        />

        {/* Banner horizontal: ad_slot_home_top (desktop) */}
        <div className="hidden md:block py-6 bg-background-100">
          <InlineBannerAd banner={inlineBanners[0]} />
        </div>

        <LandingVivaSection />

        <ExclusivitySection />

        <ComunidadSection />

        <GamificacionTotalSection />

        <TopRankingsSection />

        <ClubesSection />

        <CompetenciasSection />

        <SocialSection />

        <PublicidadSection />

        <NotificacionesInteligentesSection />

        <ReputacionSection />

        <GanadoresSection />

        <PatrocinadoresSection />

        <CopasSection />

        <EventosSection />

        <EncuestasSection />

        <TriviasSection />

        <SeguidoresSection />

        <CompartidosSection />

        <MapaSection />

        <LogrosSection />

        <TopFansGlobalesSection />

        <EmbajadoresSection />

        <RetosClubesSection />

        <VipClubSection />

        <InsigniasSection />

        <ReaccionesSection />

        <GuardadosSection />

        <CentroNotificacionesSection />

        <PerfilOyenteSection />

        <SeguirUsuariosSection />

        <CentroSocialSection />

        <MensajesPrivadosSection />

        <ModeradoresSection />

        <ReportesSection />

        <VerificacionSection />

        <FavoritosSection />

        <AchievementsEnVivoSection />

        <RachasSection />

        <AniversariosSection />

        <BienvenidaSection />

        <ActividadGlobalSection />

        <CanalRFWSection />

        <OnboardingRadiosSection />

        {/* ── Streaming — dos modelos claros ── */}
        <StreamingSection />

        <DashboardSimpleSection />

        <CentroTransmisionSection />

        <ProgramacionAutomaticaSection />

        <SistemaLocutoresSection />

        <SistemaProgramasSection />

        <Cabina2Section />

        <CancionesSolicitadasSection />

        <SistemaSaludosSection />

        <AudioMensajesSection />

        <EventosEnVivoSection />

        <ClipsSection />

        <TendenciasEnVivoSection />

        <RadiosVerificadasSection />

        <RadiosCercanasSection />

        <DescubrimientoSection />

        <PatrocinadoresLocalesSection />

        <Top10GlobalSection />

        <Top10PaisSection />
        <Top10CategoriaSection />

        <MonetizacionSection />

        <RedPublicitariaSection />

        <MarketplaceSection />

        <AppsSection />

        <TestimoniosCrecimientoSection />

        <AuditoriaLandingSection />

        <StatsSection />
        <Categories onCategorySelect={setActiveCategory} />
        <FeaturedRadios activeCategory={activeCategory} onCategoryChange={setActiveCategory} />

        {/* Recomendaciones personalizadas */}
        <div className="bg-background-100">
          <RecommendationSection
            recommendations={genericRecommendations}
            subtitle="Basado en tendencias y popularidad entre oyentes como tú."
          />
        </div>

        <AboutSection />
        <BenefitsRadios />
        <BenefitsListeners />

        {/* Banner horizontal: ad_slot_between_sections */}
        <div className="py-6 bg-background-100">
          <InlineBannerAd banner={inlineBanners[1]} />
        </div>

        <TestimonialsSection />
        <FAQSection />
        <SponsorsSection />
        <PlansSection />
        <CtaSection />

        {/* Footer sponsor */}
        <div className="py-6 bg-background-100">
          <InlineBannerAd banner={footerSponsor} />
        </div>
      </main>
      <Footer />
      <MobileBottomNav />

      {/* Spacer para mobile player + global player */}
      <div className="md:hidden h-32"></div>

      {/* Spacer para desktop global player */}
      <div className="hidden md:block h-16"></div>
    </div>
  );
}